import { memo } from 'react';
import { useApp } from '../../../../hook/app.hook';
import { Question, Section } from '../../../../response/test.response';

const JeeNavigationMComponent = () => {
  const { testRes, updateActiveQuestion, clearQuestionResponse } = useApp();

  const section = testRes.sectionList.filter(
    (section: Section) => section.active,
  )[0];

  const question = section.questionList.filter(
    (question: Question) => question.active,
  )[0];

  const handleSelect = (qId: string) => {
    if (!question.saved) {
      clearQuestionResponse(question.id);
    }
    updateActiveQuestion(qId);
  };

  const getQuestionStatus = (question: Question) => {
    const visited =
      question.timeTaken > 0 ||
      (question.attempted && question.saved) ||
      question.markedForRevisit ||
      question.active;

    if (!visited) return 'not-visited';
    if (question.attempted && question.saved && question.markedForRevisit)
      return 'answered-and-marked';
    if (question.attempted && question.saved) return 'answered';
    if (question.markedForRevisit) return 'marked-for-review';
    return 'not-answered';
  };

  const getButtonStyle = (status: string, isActive: boolean) => {
    const baseStyle: React.CSSProperties = {
      width: '36px',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: '12px',
      border: isActive ? '2px solid #007bff' : 'none',
      position: 'relative',
    };

    switch (status) {
      case 'not-visited':
        return {
          ...baseStyle,
          backgroundColor: '#e0e0e0',
          color: '#666',
          borderRadius: '4px',
        };
      case 'not-answered':
        return {
          ...baseStyle,
          backgroundColor: '#dc3545',
          color: 'white',
          clipPath: isActive
            ? undefined
            : 'polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%)',
          borderRadius: isActive ? '4px' : undefined,
        };
      case 'answered':
        return {
          ...baseStyle,
          backgroundColor: '#28a745',
          color: 'white',
          clipPath: isActive
            ? undefined
            : 'polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%)',
          borderRadius: isActive ? '4px' : undefined,
        };
      case 'marked-for-review':
      case 'answered-and-marked':
        return {
          ...baseStyle,
          backgroundColor: '#6f42c1',
          color: 'white',
          borderRadius: '50%',
        };
      default:
        return baseStyle;
    }
  };

  return (
    <div
      className="p-2 rounded"
      style={{
        maxHeight: '180px',
        overflowY: 'auto',
        backgroundColor: '#f8f9fa',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(36px, 1fr))',
          gap: '8px',
        }}
      >
        {section.questionList.map((q: Question) => {
          const status = getQuestionStatus(q);
          const isActive = q.active;
          const buttonStyle = getButtonStyle(status, isActive);

          return (
            <button
              key={q.id}
              style={buttonStyle}
              onClick={() => handleSelect(q.id)}
            >
              {q.index}
              {status === 'answered-and-marked' && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '2px',
                    right: '2px',
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#28a745',
                    borderRadius: '1px',
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default memo(JeeNavigationMComponent);
